<div id="third">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                   
                    <div class="card-body">
                        
                        <iframe src="https://drive.google.com/file/d/1Tow-VcTAcrPP55ZPRF828N9325l1EMME/preview" width="100%" height="1100px" allow="autoplay"></iframe>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>